const header = document.querySelector(".shipping-picker > .header");
const expressOption = document.querySelector(".shipping-picker .option.express");

const isAtcTemplate = document.getElementById("isAtcTemplate")?.value === "true";
const isNonAtcExpressDelivery = document.getElementById("expressDelivery")?.value === "true";

const hideExpressAtcButton = document.getElementById("hideExpressAtcButton")?.value === "true";

const isWhoopSwatch = document.getElementById("isWhoopSwatch")?.value === "true";

const isExpressTemplate = (isAtcTemplate || isNonAtcExpressDelivery);
const isExpressProduct = document.getElementById("marketHandle")?.value === "ae" && document.getElementById("isExpressProduct")?.value === "true";

const swatchSelector = ".globo-swatch-list ul:not(.ul-swatches-list)";
let colorLegend = 'color';

const priceSelector = ".price .money, .price bdi, .price";
const expressPriceSelector = ".express-price .money, .express-price bdi, .express-price";

function legacyLegendSelector(name) {
    return `div.ms-variant-radios fieldset[data-option-slug*="${name}" i] > legend`
}

function legendSelector(name) {
    return `.globo-swatch-list legend[data-name*="${name}" i]`;
}

// Configuration
const CONFIG = {
    maxRetries: 10,
    retryDelay: 250,
    pollInterval: 250,
    globoTimeout: 1000
};

// State tracking
let retryCount = 0;
let isInitialized = false;
let globoListenerAttached = false;

// Wait for both DOM and critical elements
function waitForElement(selector, timeout = 10000) {
    return new Promise((resolve, reject) => {
        const element = document.querySelector(selector);
        if (element) {
            resolve(element);
            return;
        }

        const startTime = Date.now();
        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                resolve(element);
            } else if (Date.now() - startTime > timeout) {
                clearInterval(checkInterval);
                reject(new Error(`Element ${selector} not found within ${timeout}ms`));
            }
        }, 100);
    });
}

// Wait for Globo swatch to be ready
function waitForGloboSwatch() {
    return new Promise((resolve) => {
        // Check if Globo swatch is already loaded
        if (document.querySelector(swatchSelector) || window.Globo?.Swatch?.isLoaded) {
            resolve();
            return;
        }

        let resolved = false;
        let timeoutId = null;

        // Listen for Globo swatch loaded event
        const globoHandler = () => {
            if (!resolved) {
                resolved = true;
                clearTimeout(timeoutId);
                resolve();
            }
        };

        // Add event listener if not already added
        if (!globoListenerAttached) {
            window.addEventListener('Globo.swatch.loaded', globoHandler);
            globoListenerAttached = true;
        }

        // Set a timeout to proceed even if Globo doesn't load
        timeoutId = setTimeout(() => {
            if (!resolved) {
                resolved = true;
                console.warn('Globo swatch did not load within timeout, proceeding anyway');
                resolve();
            }
        }, CONFIG.globoTimeout);
    });
}

// Enhanced initialization with retry logic
async function initializeShippingPicker() {
    if (isInitialized) return;

    try {
        // Wait for critical elements
        await waitForElement('body');

        // Wait for Globo swatch to be ready (or timeout)
        await waitForGloboSwatch();

        // Create fallback pricing data if globo-swatch-detail-lists-price is missing
        setupInitialSwatches();

        // Set up event listeners for future swatch changes
        setupSwatchEventListeners();

        isInitialized = true;
        console.log('Shipping picker initialized successfully');

    } catch (error) {
        retryCount++;
        if (retryCount < CONFIG.maxRetries) {
            console.warn('Initialization failed, retrying...', error);
            setTimeout(() => initializeShippingPicker(), CONFIG.retryDelay);
        } else {
            console.error('Max retries reached, giving up');
        }
    }
}

// Process swatch updates (called from event listeners)
function processSwatchUpdates() {
    // Remove express shipping input if not an express product
    if (!isExpressProduct) {
        const expressInput = document.querySelector('input[name="properties[Express Shipping]"]');
        expressInput?.remove();
    }

    // Hide shipping picker header or entire row based on template
    if (!isAtcTemplate) {
        const standardLabel = document.querySelector("div.row:not(.color-express)");

        if (!isNonAtcExpressDelivery && header) {
            header.style.display = "none";
        } else if (standardLabel) {
            standardLabel.style.display = "none";
        }
    }

    // Process all swatches
    document.querySelectorAll(swatchSelector).forEach(ul => {
        const parentDiv = ul.closest('.swatch--gl');
        if (!parentDiv) return;
        ul.querySelectorAll('li').forEach(li => processSwatchItem(li, parentDiv));
    });
}

// Process individual swatch item
function processSwatchItem(li, parentDiv) {
    const label = li.querySelector("label.swatch-anchor");
    if (!label) return;

    const isColorSwatch = !!parentDiv.querySelector(`legend[data-name*="${colorLegend}" i]`);
    const isSizeSwatch = !!parentDiv.querySelector('legend[data-name*="size" i]');
    const isStampSwatch = !!parentDiv.querySelector('legend[data-name*="stamp" i]');

    // Get current selections
    const colorInput = document.querySelector(`${legendSelector(colorLegend)} ~ ul.value li input:checked`);
    const sizeInput = document.querySelector(`${legendSelector("size")} ~ ul.value li input:checked`);
    const color = colorInput?.value;
    const size = sizeInput?.value;

    // Determine values for this swatch
    const swatchInput = li.querySelector("input");
    const swatchValue = swatchInput?.value;

    let currentColor = color;
    let currentSize = size;

    if (isColorSwatch && size) {
        currentColor = swatchValue;
    } else if (isSizeSwatch && color) {
        currentSize = swatchValue;
    } else {
        isColorSwatch && (currentColor = swatchValue);
        isSizeSwatch && (currentSize = swatchValue);
    }

    // Find matching variant
    const variantData = findVariantData(currentColor, currentSize, isSizeSwatch);
    updateSwatchVisuals(label, variantData, isColorSwatch, isSizeSwatch);

    // Add click listener if needed
    if (!swatchInput.hasAttribute("data-shipping-picker-injected")) {
        swatchInput.addEventListener("change", () => {
            getSwatchItemPrice(li, isColorSwatch);
            isStampSwatch && updateDetail("STAMP", label.textContent.trim());
        });
        swatchInput.setAttribute("data-shipping-picker-injected", "true");
    }
}

// Setup event listeners for swatch changes
function setupSwatchEventListeners() {
    // Listen for changes on all swatch inputs
    document.querySelectorAll(`${swatchSelector} li input`).forEach(input => {
        if (!input.hasAttribute("data-shipping-picker-injected")) {
            const li = input.closest("li");
            const swatch = li?.closest('.swatch--gl');
            const isColorSwatch = !!swatch?.querySelector(`legend[data-name*="${colorLegend}" i]`);
            const isStampSwatch = !!swatch?.querySelector('legend[data-name*="stamp" i]');
            
            input.addEventListener("change", function () {
                const currentLi = this.closest("li");
                const currentSwatch = currentLi?.closest('.swatch--gl');
                const isColor = !!currentSwatch?.querySelector(`legend[data-name*="${colorLegend}" i]`);
                const isStamp = !!currentSwatch?.querySelector('legend[data-name*="stamp" i]');
                
                // Process the swatch update
                if (currentLi && currentSwatch) {
                    processSwatchItem(currentLi, currentSwatch);
                }
                
                getSwatchItemPrice(currentLi, isColor);
                if (isStamp) {
                    const label = currentLi?.querySelector("label.swatch-anchor");
                    updateDetail("STAMP", label?.textContent.trim() || "");
                }
            });
            input.setAttribute("data-shipping-picker-injected", "true");
        }
    });
}

// Helper function to find variant data
function findVariantData(color, size, isSizeSwatch) {
    let selector = "#airtable-data div";
    if (color) {
        selector += `[data-color="${color.replace(/'/g, "\\'")}"]`;
    }
    if (isSizeSwatch && size) {
        selector += `[data-size="${size.replace(/'/g, "\\'")}"]`;
    }

    return document.querySelector(selector);
}

// Update swatch visuals
function updateSwatchVisuals(label, variantData, isColorSwatch, isSizeSwatch) {
    const variantId = variantData?.dataset?.variantId;
    const expressPriceSpan = variantData?.querySelector(expressPriceSelector);
    const quantity = variantData?.dataset?.quantity;

    const isExpressVariant = quantity > 0 && expressPriceSpan;

    // Add whoop class if applicable
    if (isColorSwatch && isWhoopSwatch) {
        label.style.setProperty('width', '100px', 'important');
        label.style.setProperty('height', '120px', 'important');
        label.style.setProperty('border-radius', '1rem', 'important');
    }

    // Update dot indicator with Sand inventory consideration
    isExpressProduct && updateDotIndicator(label, isExpressVariant, isColorSwatch, variantData);

    // Add price for size swatches
    isSizeSwatch && variantId && addPriceToSizeSwatch(variantData, label);
}

function updateDetail(position, text) {
    const detail = document.querySelector(`span[data-detail="${position}"]`);
    if (!detail) return;
    detail.textContent = text;
}

function updateExpressOptionState(expressPriceSpan, isExpressVariant, options = {}) {
    if (!expressOption) return;

    const {
        autoSelect = false,
        quantity = null,
        hideWhenUnavailable = true
    } = options;

    if (expressPriceSpan && isExpressVariant) {
        expressOption.style.display = "";
        const expressPriceDiv = expressOption.querySelector(".price");
        expressPriceDiv && (expressPriceDiv.innerHTML = expressPriceSpan.cloneNode(true).innerHTML);
        autoSelect && expressOption.click();
        if (quantity !== null) {
            const inventoryField = document.querySelector("#inventoryQuantity");
            inventoryField && (inventoryField.value = quantity);
        }
    } else {
        // Remove Shipping Method input if it exists
        const expressInput = document.querySelector('input[name="properties[Express Shipping]"]');
        expressInput?.remove();
        hideWhenUnavailable && (expressOption.style.display = "none");
    }
}

function updateAtcButtonVisibility(isExpressVariant) {
    const atcButton = document.querySelector(".product-form__buttons");
    if (!atcButton) return;

    atcButton.style.display = (
        (!isAtcTemplate && !isExpressVariant)
        || (isExpressVariant && hideExpressAtcButton)
    ) ? "none" : "";
}

// Update dot indicator
function updateDotIndicator(label, isExpressVariant, isColorSwatch, variantData) {
    // Remove existing dots
    const oldDot = label.querySelector(".dot.express, .dot.standard");
    oldDot?.remove();

    // Determine dot type
    let dotType = "standard";

    if (isColorSwatch && variantData) {
        // Check if any variants for this color have quantity and express price
        const color = variantData.dataset.color;
        const colorVariants = document.querySelectorAll(`#airtable-data div[data-color="${color.replace(/'/g, "\\'")}"]`);
        const hasExpressVariants = Array.from(colorVariants).some(variant => {
            return variant.dataset.quantity > 0 && (variant.querySelector(expressPriceSelector) !== null);
        });

        dotType = isExpressProduct && hasExpressVariants ? "express" : "standard";
    } else if (isExpressProduct && isExpressVariant) {
        dotType = "express";
    }

    // Add new dot
    const dot = document.createElement("span");
    dot.className = `dot ${dotType}`;
    label.insertBefore(dot, label.firstChild);
}

// Add price to size swatch
function addPriceToSizeSwatch(variantData, label) {
    const priceSpan = variantData?.querySelector(priceSelector);

    if (priceSpan) {
        // Remove existing price if any
        const existingPrice = label.querySelector(".money, bdi, .price");
        if (existingPrice) {
            const prev = existingPrice.previousSibling;
            prev?.tagName === 'BR' && prev.remove();
            existingPrice.remove();
        }

        // Add new price
        const br = document.createElement("br");
        const clonedPrice = priceSpan.cloneNode(true);
        label.appendChild(br);
        label.appendChild(clonedPrice);
    }
}

// Initial swatch setup
function setupInitialSwatches() {
    colorLegend = document.querySelector(legendSelector("color")) ? "color" : "colour";
    if (document.querySelector(swatchSelector)) {
        // Find the first available swatch to trigger initial update
        let currentUl = document.querySelector(`${legendSelector("size")} ~ ul.value`);
        if (!currentUl) {
            currentUl = document.querySelector(`${legendSelector(colorLegend)} ~ ul.value`);
        }
        if (!currentUl) {
            currentUl = document.querySelector(".globo-swatch-list legend ~ ul.value");
        }

        const checkedInput = currentUl?.querySelector("li input:checked");
        const li = checkedInput ? checkedInput.closest("li") : currentUl?.querySelector("li");
        const swatch = currentUl?.closest('.swatch--gl');
        const label = li?.querySelector("label.swatch-anchor");

        li && getSwatchItemPrice(li, !!swatch?.querySelector(`legend[data-name*="${colorLegend}" i]`));
        swatch?.querySelector('legend[data-name*="stamp" i]') && updateDetail("STAMP", label?.textContent.trim());
    } else {
        // Fallback for non-swatch products
        setupNonSwatchProduct();
    }
    
    processSwatchUpdates();
}

// Get swatch item price and update UI with Sand inventory integration
function getSwatchItemPrice(li, isColorSwatch = false) {
    // Get selected color from checked inputs
    let colorInput = document.querySelector(`${legendSelector(colorLegend)} ~ ul.value li input:checked`);
    let color = colorInput?.value;
    const variantDataBaseSelector = "#airtable-data div";

    // Only update size swatches if isColorSwatch is true and size swatches exist
    if (isColorSwatch && (document.querySelector(`${legendSelector("size")} ~ ul.value`) || document.querySelector(legacyLegendSelector("size")))) {
        document.querySelectorAll(`${legendSelector("size")} ~ ul.value li`).forEach(sizeLi => {
            const label = sizeLi.querySelector("label.swatch-anchor");
            if (label) {
                const sizeInput = sizeLi.querySelector("input");
                const size = sizeInput?.value;

                // Find matching variantData by color/size
                const selector = `${variantDataBaseSelector}[data-color="${color.replace(/'/g, "\\'")}"][data-size="${size.replace(/'/g, "\\'")}"]`;
                const variantData = document.querySelector(selector);
                const variantId = variantData?.dataset?.variantId;
                const expressPriceSpan = variantData?.querySelector(expressPriceSelector);
                const quantity = variantData?.dataset?.quantity;

                const isExpressVariant = quantity > 0 && expressPriceSpan;

                if (isExpressProduct) {
                    // Remove existing .dot
                    const oldDot = label.querySelector(".dot.express, .dot.standard");
                    oldDot?.remove();

                    // Add .dot.express or .dot.standard
                    const dot = document.createElement("span");
                    dot.className = "dot " + (isExpressVariant ? "express" : "standard");
                    label.insertBefore(dot, label.firstChild);
                }

                // Add price for size swatch
                addPriceToSizeSwatch(variantData, label);
            }
        });
    }

    // Get selected size from checked inputs
    let sizeInput = document.querySelector(`${legendSelector("size")} ~ ul.value li input:checked`);

    // Check if the checked input's parent li has globo-out-of-stock class
    if (sizeInput && sizeInput.closest("li")?.classList.contains("globo-out-of-stock")) {
        // Find the first input that doesn't have globo-out-of-stock in parent li
        const sizeInputs = document.querySelectorAll(`${legendSelector("size")} ~ ul.value li input`);
        sizeInput = Array.from(sizeInputs).find(input => !input.closest("li")?.classList.contains("globo-out-of-stock")) || sizeInput;
        sizeInput.checked = true;
        sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
        return; // Wait for the change event to trigger the price update
    }
    const size = sizeInput?.value;

    // If no color or size inputs are checked, try to find any checked input in the swatch list as a fallback
    if (!colorInput && !sizeInput) {
        colorInput = document.querySelector(`.globo-swatch-list legend ~ ul.value li input:checked`);
        color = colorInput?.value;
    }

    // Find the matching variant in #airtable-data
    let selector = variantDataBaseSelector;
    if (color) {
        selector += `[data-color="${color.replace(/'/g, "\\'")}"]`;
    }
    if (size) {
        selector += `[data-size="${size.replace(/'/g, "\\'")}"]`;
    }
    const variantData = document.querySelector(selector);
    const variantId = variantData?.dataset?.variantId;
    const priceSpan = variantData?.querySelector(priceSelector);
    const expressPriceSpan = variantData?.querySelector(expressPriceSelector);
    const quantity = variantData?.dataset?.quantity;
    const preloved = variantData?.dataset?.preloved === "true";
    const newVariant = variantData?.dataset?.newVariant === "true";

    typeof updateProgressBar === 'function' && updateProgressBar(variantData?.dataset?.condition);
    updateDetail("CONDITION", variantData?.dataset?.condition || "Not specified");

    updateDetail("INCLUSIONS", variantData?.dataset?.inclusions || "Not specified");

    document.querySelector("#inventoryQuantity").value = quantity;

    const isExpressVariant = quantity > 0 && expressPriceSpan;

    // Show or hide express badge on product images
    document.querySelectorAll(".product__modal-opener--image .express-badge").forEach(el => {
        el.style.display = isExpressTemplate && isExpressVariant ? "flex" : "none";
    });
    document.querySelectorAll(".preloved-badge").forEach(el => {
        el.style.display = preloved ? "flex" : "none";
    });
    document.querySelectorAll(".new-variant-badge").forEach(el => {
        el.style.display = newVariant ? "block" : "none";
    });
    const prelovedBlock = document.querySelector(".preloved-block");
    if (prelovedBlock) {
        prelovedBlock.style.display = preloved ? "flex" : "none";
    }

    // Show or hide shipping picker header
    if (header) {
        header.style.display = isExpressVariant ? "" : "none";
    }

    // Update main product price display
    if (priceSpan) {
        // Show and update standard price
        const standardOption = document.querySelector(".shipping-picker .option.standard");
        if (standardOption) {
            if (priceSpan && isExpressVariant) {
                standardOption.style.display = "";
                const standardPriceDiv = standardOption.querySelector(".price");
                if (standardPriceDiv) {
                    standardPriceDiv.innerHTML = priceSpan.cloneNode(true).innerHTML;
                }
            }
            else {
                standardOption.style.display = "none";
            }
        }
    }

    // Show and update express price
    updateExpressOptionState(expressPriceSpan, isExpressVariant, {
        hideWhenUnavailable: true
    });

    // Show and update add to cart button
    updateAtcButtonVisibility(isExpressVariant);

    // Select first visible shipping option
    const selectedOption = document.querySelector(".shipping-picker .option.selected");
    selectedOption?.classList.remove("selected");
    const shippingOptions = document.querySelectorAll(".shipping-picker .option");
        const shippingOption = Array.from(shippingOptions)
            .find(opt => opt.offsetParent !== null && window.getComputedStyle(opt).display !== "none");
        shippingOption?.click();
}

// Fallback for non-swatch products
function setupNonSwatchProduct() {
    const variantData = document.querySelector("#airtable-data div");
    if (!variantData) return;

    const quantity = variantData?.dataset?.quantity;
    const preloved = variantData?.dataset?.preloved === "true";

    typeof updateProgressBar === 'function' && updateProgressBar(variantData?.dataset?.condition);
    updateDetail("CONDITION", variantData?.dataset?.condition || "Not specified");

    updateDetail("INCLUSIONS", variantData?.dataset?.inclusions || "Not specified");

    const expressPriceSpan = variantData?.querySelector(expressPriceSelector);
    const isExpressVariant = quantity > 0 && expressPriceSpan;

    updateExpressOptionState(expressPriceSpan, isExpressVariant, {
        autoSelect: true,
        quantity,
        hideWhenUnavailable: false
    });

    updateAtcButtonVisibility(isExpressVariant);

    document.querySelectorAll(".product__modal-opener--image .express-badge").forEach(el => {
        el.style.display = isExpressProduct && isExpressVariant ? "flex" : "none";
    });
    document.querySelectorAll(".preloved-badge").forEach(el => {
        el.style.display = preloved ? "flex" : "none";
    });
    document.querySelectorAll(".new-variant-badge").forEach(el => {
        el.style.display = newVariant ? "block" : "none";
    });
    const prelovedBlock = document.querySelector(".preloved-block");
    if (prelovedBlock) {
        prelovedBlock.style.display = preloved ? "flex" : "none";
    }
}

// Start initialization with Globo swatch detection
function startInitialization() {
    // Only initialize once
    if (isInitialized) return;

    // Check if Globo swatch is already loaded
    if (document.querySelector(swatchSelector) || window.Globo?.Swatch?.isLoaded) {
        initializeShippingPicker();
        return;
    }

    // Listen for Globo swatch loaded event
    const globoHandler = () => {
        if (!isInitialized) {
            initializeShippingPicker();
        }
    };

    if (!globoListenerAttached) {
        window.addEventListener('Globo.swatch.loaded', globoHandler);
        globoListenerAttached = true;
    }

    // Set a timeout to initialize even if Globo doesn't load
    setTimeout(() => {
        if (!isInitialized) {
            console.warn('Globo swatch did not load within timeout, initializing anyway');
            initializeShippingPicker();
        }
    }, CONFIG.globoTimeout);

    // Also initialize on DOM ready if Globo is not present
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        // If DOM is ready and Globo hasn't loaded after a short delay, initialize
        setTimeout(() => {
            if (!isInitialized) {
                initializeShippingPicker();
            }
        }, CONFIG.globoTimeout / 2);
    }
}

// Start the initialization process
startInitialization();

// Also handle the case where Globo loads after DOM ready
document.addEventListener('DOMContentLoaded', () => {
    // If not initialized yet, check again
    setTimeout(() => {
        if (!isInitialized) {
            initializeShippingPicker();
        }
    }, 1000);
});